import React from 'react';

import cn from 'classnames';

import { Color } from 'types/colors';

import { FemtasyIcon } from './iconsType';
import './style.scss';

export type iconSize = '12' | '14' | '16' | '20' | '24' | '32' | '40' | '120' | '136';

interface IProps {
  className?: string;
  color?: Color | 'inherit';
  icon: FemtasyIcon;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  size?: iconSize;
  testId?: string;
  ref?: React.Ref<HTMLDivElement>;
}

const IconFemtasy = ({
  className,
  color = 'white',
  icon,
  onClick,
  ref,
  size = '24',
  testId,
}: IProps) => {
  const classNames = cn(
    'FemtasyIcon',
    color !== 'inherit' && `FemtasyIcon--${color}`,
    `icon-${icon}`,
    `size-${size}`,
    className,
    { clickable: !!onClick },
  );

  return (
    <div
      aria-label={icon}
      className={classNames}
      data-testid={testId}
      onClick={onClick}
      role="img"
      ref={ref}
    />
  );
};

export default IconFemtasy;
